<template>
 <div id="index">
    <a name="top"></a>
    <d-head></d-head>
    <router-view></router-view>
    <d-foot></d-foot>
    <top></top>
 </div>
</template>
<script>
import DHead from '@/components/DHead.vue';
import DFoot from '@/components/DFoot.vue';
import Top from '@/components/Top.vue';
export default {
  name: 'Index',
  components: {
    DHead,
    DFoot,
    Top
  },
  data() {
    return {

    }
  },
  created() {
  }
}
</script>
<style scoped lang="less">
  #foot {
    p {
      color: @theme-color;
    }
  }
</style>
